import { useDispatch, useSelector } from 'react-redux'
import { getEnteringInputDialog } from '../../Selectors'
import { setEnteringInputDialog } from '../../ActionCreators'
import styles from './VNEnteringTipDialog.module.scss'
import { useEffect, useRef, useState } from 'react'
import cn from 'classnames'
import { Button } from '@material-ui/core'

export const VNEnteringInputDialog = () => {
  const classNames = cn(styles.emailReceiptModal)

  const dialogOptions = useSelector((state) => getEnteringInputDialog(state))
  const dispatch = useDispatch()
  const inputRef = useRef(null)
  const [input, setInput] = useState(dialogOptions?.get('defaultValue') || '')

  useEffect(() => {
    if (dialogOptions?.get('preselect') && dialogOptions?.get('open') && inputRef?.current) {
      inputRef?.current?.select()
    }

    if (dialogOptions?.get('defaultValue')) {
      setInput(dialogOptions.get('defaultValue'))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dialogOptions?.get('open')])

  if (!dialogOptions?.get('open')) {
    return null
  }

  const resetInput = () => {
    setInput('')
    if (inputRef.current) {
      inputRef.current.value = ''
    }
  }

  return (
    <div className={classNames}>
      <div className={styles.overlay}></div>
      <div className={styles.content}>
        <div className={styles.title}>{dialogOptions?.get('title') || ''}</div>
        <div className={styles.subtext}>{dialogOptions?.get('subTitle') || ''}</div>
        <div className={styles.inputContainer}>
          {dialogOptions?.get('multiLine') ? (
            <textarea
              ref={inputRef}
              data-allow-keyboard-activity
              minLength={0}
              onInput={(e) => {
                const maxLength = dialogOptions?.get('maxLength')
                let value = e.target.value
                value = value.replace(dialogOptions?.get('regexExpression'), '')
                if (maxLength && value.length > maxLength) {
                  value = value.slice(0, maxLength)
                }
                e.target.value = value
                setInput(value)
              }}
              maxLength={dialogOptions?.get('maxLength') || null}
              className={cn(styles.inputField, styles.textArea)}
              autoFocus
              defaultValue={dialogOptions?.get('defaultValue') || ''}
              onChange={(e) => {
                if (dialogOptions?.get('maxLength') && e.target.value.length > dialogOptions?.get('maxLength')) {
                  return
                }
                setInput(e.target.value)
              }}
            />
          ) : (
            <input
              ref={inputRef}
              onInput={(e) => {
                const maxLength = dialogOptions?.get('maxLength')
                let value = e.target.value
                if (maxLength && value.length > maxLength) {
                  value = value.slice(0, maxLength)
                  e.target.value = value
                }
                setInput(value)
              }}
              data-allow-keyboard-activity
              maxLength={dialogOptions?.get('maxLength') || null}
              type={dialogOptions?.get('type') || 'text'}
              className={styles.inputField}
              autoFocus
              defaultValue={dialogOptions?.get('defaultValue') || ''}
              onChange={(e) => {
                setInput(e.target.value)
              }}
            />
          )}
        </div>
        <div className={styles.buttonContainer}>
          <Button
            onClick={() => {
              resetInput()
              dispatch(setEnteringInputDialog({ open: false }))
            }}
            className={styles.cancelButton}
          >
            {dialogOptions?.get('onCancelText') || 'Cancel'}
          </Button>
          <div className={styles.partition} />
          <Button
            onClick={() => {
              dialogOptions?.get('onSave')(input)
              resetInput()
            }}
            className={styles.sendButton}
            disabled={input === ''}
          >
            {dialogOptions?.get('onSaveText') || 'Save'}
          </Button>
        </div>
      </div>
    </div>
  )
}
